export const UTB_REPORT_OBJECTION_CLAUSE_DAYS = 43;
export const UTB_REPORT_DECIMAL_PLACES = 2;
